import { createContext, useContext } from 'react';

/**
 * Context value for displaying toast notifications
 */
export interface SnackbarContextValue {
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
  showInfo: (message: string) => void;
}

export const SnackbarContext = createContext<SnackbarContextValue | null>(null);

/**
 * Hook to access snackbar notification functions
 * @throws Error if used outside of SnackbarProvider
 */
export function useSnackbar(): SnackbarContextValue {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
}
